/**
 * Данные по продукту.
 */
export class ProductData {
  /**
   * Заголовок.
   */
  public Caption: string = "";

  /**
   * Картинка.
   */
  public Image: string = "";

  /**
   * Массив картинок.
   */
  public Images: Array<string> = [];

  /**
   * URL страницы.
   */
  public Url: string = "";

  /**
   * Является ли операцией
   */

  public IsOperation: boolean = false;

  /**
   * Идентификатор операции каталога.
   */
  public CatalogId: number | null = null;

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src != null) {
      this.Caption = src.caption ?? "";
      this.Image = src.image ?? "";
      this.IsOperation = (src.isOperation === 'true') ?? false;
      if (src.images) {
        src.images.forEach((img: string) => {
          if (img) {
            this.Images.push(img);
          }
        });
      }
      this.Url = src.url ?? "";
      this.CatalogId = src.catalogId ?? null;
    }
  }
}
